import { z } from 'zod';
import { LOOK, SourceRefSchema, about, sourceOf } from '../schema_fields.ts';

// The text tile (docs/specs/text-tile.md, issue #22): one text, the tile's own or a source's value.

export const TEXT_ALIGNMENTS = ['left', 'center', 'right'] as const;
export const TEXT_VERTICAL_ALIGNMENTS = ['top', 'center', 'bottom'] as const;

export const TextOptionsSchema = z.object({
    text: z.string().default('').meta(about('Text', 'shown where the tile reads no source')),
    // Read where the tile has a data source by this name, else the text above (TX-2).
    source: sourceOf(SourceRefSchema, { gives: ['text', 'number', 'onOff', 'level'], label: 'Reading', whenUnset: 'None: the tile’s own text' }, 'its value instead of the text'),
    /** Text only, after a reading's number (TX-7), as a value tile's (tiles spec TU-1). */
    unit: z.string().default('').meta(about('Unit', 'shown after a reading\'s number, such as W or °C')),
    size: z.number().positive().default(20).meta({ ...about('Text size', 'in pixels'), ...LOOK }),
    align: z.enum(TEXT_ALIGNMENTS).default('center').meta({
        ...LOOK,
        ...about('Alignment', 'across'),
        'x-labels': { left: 'Left', center: 'Centre', right: 'Right' },
    }),
    valign: z.enum(TEXT_VERTICAL_ALIGNMENTS).default('center').meta({
        ...LOOK,
        ...about('Vertical alignment', 'up and down'),
        'x-labels': { top: 'Top', center: 'Middle', bottom: 'Bottom' },
    }),
    wrap: z.boolean().default(true).meta({ ...about('Word wrap', 'off: each line stays one line, cut off at the edge'), ...LOOK }),
});
